// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VcHQ2","title":"styles_title__eHamo"};